export enum RiskControlTabs {
  Global = 'Global',
  Organization = 'Organization',
  Account = 'Account',
  RiskGroup = 'Risk Group',
}

/**
 * Query-param / list-selection sentinel: show every account-scoped control.
 * Namespaced (like ALL_VIEW_ID / SELECT_ALL_ITEM_VALUE elsewhere) so it can
 * never collide with a real custodian account id.
 */
export const ALL_ACCOUNTS_SELECTION = '__all_accounts__'

export function isAllAccountsSelection(
  selectedAccount: string | null | undefined,
): boolean {
  return selectedAccount === ALL_ACCOUNTS_SELECTION
}
